import { CountryRiskIndex } from '@grid-ui/common';
import { ItemInformationListingItemDatatype } from '../item-information-listing';

export function isCountryRiskIndex(data: ItemInformationListingItemDatatype): data is CountryRiskIndex {
  return (data as CountryRiskIndex).edition !== undefined;
}
